import React, { createContext, useContext, useState, useEffect } from 'react';

// Light theme colors
export const lightTheme = {
  navy: '#194984',
  green: '#75ba68',
  lightGreen: '#a4c854',
  teal: '#37b3a7',
  blue: '#096cb4',
  yellow: '#ffd460',
  pale: '#f0f9fc',
  white: '#ffffff',
  text: '#1e3a5c',
  muted: '#6b8299',
  border: '#e4eaf0',
  bg: '#f8fafb',
  cardBg: '#ffffff',
  sidebarBg: '#ffffff',
  headerBg: '#194984',
  headerText: '#ffffff',
  inputBg: '#ffffff',
  inputBorder: '#e4eaf0',
};

// Dark theme colors
export const darkTheme = {
  navy: '#0d2b4f',
  green: '#5a9b4f',
  lightGreen: '#8ab84a',
  teal: '#2d8f84',
  blue: '#0a5a9e',
  yellow: '#e6c04a',
  pale: '#1a2a3a',
  white: '#1e2a3a',
  text: '#e0e0e0',
  muted: '#9aabb8',
  border: '#2a3a4a',
  bg: '#0f1720',
  cardBg: '#1a2535',
  sidebarBg: '#111827',
  headerBg: '#0d2b4f',
  headerText: '#ffffff',
  inputBg: '#1a2535',
  inputBorder: '#2a3a4a',
};

export const AI_COLOR = '#7c3aed';
export const AI_LIGHT = '#f5f3ff';

// Default B export for backward compatibility (light theme)
export const B = lightTheme;

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [aiMode, setAiMode] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved === 'true';
  });

  // Get current theme colors based on mode
  const theme = isDarkMode ? darkTheme : lightTheme;

  // Apply theme to body
  useEffect(() => {
    if (isDarkMode) {
      document.body.style.backgroundColor = darkTheme.bg;
      document.body.style.color = darkTheme.text;
    } else {
      document.body.style.backgroundColor = lightTheme.bg;
      document.body.style.color = lightTheme.text;
    }
    localStorage.setItem('darkMode', isDarkMode);
  }, [isDarkMode]);

  const toggleDarkMode = () => setIsDarkMode(prev => !prev);
  const toggle = () => setAiMode(m => !m);

  return (
    <ThemeContext.Provider value={{ 
      aiMode, 
      toggle, 
      theme,
      B: theme,
      AI_COLOR, 
      AI_LIGHT,
      isDarkMode,
      toggleDarkMode,
      lightTheme,
      darkTheme
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}